module.exports = __webpack_public_path__ + "media/images/diy/carousel_next_icon-f5308e1f27e0e7b1a3e0e7b7c1e9d553.svg";